import { tabsAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
	createMultiStyleConfigHelpers(tabsAnatomy.keys);

const primary500 = "primary.500";
const primaryAccent500 = "primary-accent.500";

const primaryAccent = definePartsStyle({
	tab: {
		position: "relative",
		overflow: "hidden",
		zIndex: 1,
		bgColor: "transparent",
		rounded: "xl",
		border: (theme) => `1px solid ${theme.colors["primary-accent"][500]}`,
		textColor: "primary-accent.50",
		_selected: {
			bgColor: primaryAccent500,
			textColor: primary500,
		},

		_hover: {
			_before: {
				content: `""`,
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				background: primaryAccent500,
				zIndex: 0,
				opacity: 0.2,
			},
			textColor: primaryAccent500,
			_selected: {
				bgColor: primaryAccent500,
				textColor: primary500,
			},
		},
	},
	tabpanel: {
		paddingX: 0,
	},
	tablist: {
		gap: 4,
	},
});

export const Tabs = defineMultiStyleConfig({
	variants: { "primary-accent": primaryAccent },
});
